var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCloseGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6062 0.393823C15.0811 -0.131274 14.2297 -0.131274 13.7046 0.393823L8 6.09846L2.29537 0.393823C1.77027 -0.131274 0.91892 -0.131274 0.393823 0.393823C-0.131275 0.91892 -0.131274 1.77027 0.393823 2.29537L6.09846 8L0.393823 13.7046C-0.131275 14.2297 -0.131274 15.0811 0.393823 15.6062C0.91892 16.1313 1.77027 16.1313 2.29537 15.6062L8 9.90154L13.7046 15.6062C14.2297 16.1313 15.0811 16.1313 15.6062 15.6062C16.1313 15.0811 16.1313 14.2297 15.6062 13.7046L9.90154 8L15.6062 2.29537C16.1313 1.77027 16.1313 0.91892 15.6062 0.393823Z",
    fill: "#677B99"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseGrey);
export default __webpack_public_path__ + "static/media/iconCloseGrey.fee84c6976243d242abf64fbb0b6d704.svg";
export { ForwardRef as ReactComponent };